import { HTTP } from "@/utils/http-common"
export default {
  list: function ($) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/account/notifications/all`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  markRead: function ($) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/account/notifications/all`, {})
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  }
}
